var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',{staticClass:"text-h6 text-center"},[_vm._v("Great job! And by “job” we don’t mean “hand job” or “blow job” 😜")])])}
var staticRenderFns = []

export { render, staticRenderFns }